import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import BackIcon from 'components/Icons/BackIcon';

const HistoryHeader = ({
  backupPreviewId,
  backupPreviewLoading,
  restoreProposal,
  restoring,
  approved,
  isWix,
}) => {
  const history = useHistory();
  const [restored, setRestored] = useState(null);

  const onRestore = () => {
    setRestored(backupPreviewId);
    restoreProposal(backupPreviewId);
  };

  const handleBack = () => {
    history.goBack();
  };

  //  show restore button for
  //   1. prevent restore if already approved
  //   2. backupPreviewId is set (backup id is required for restore)
  //   3. backupPreviewId is not = 'live' (live proposal can't be restored)
  const showRestoreBtn = !approved && backupPreviewId && backupPreviewId !== 'live';
  const restoreBtnProps = {
    loading: restoring.state === 'restoring',
    disabled: backupPreviewLoading || restored === backupPreviewId, // (since already restored so we hide the button)
    onClick: onRestore,
  };

  if (isWix) {
    if (!showRestoreBtn) {
      return null;
    }

    return (
      <Button className="wixPreview-button" {...restoreBtnProps}>
        <span className="link-text">Restore</span>
      </Button>
    );
  }

  return (
    <div className="main-wrapper history">
      <div className="block block-1">
        <Button className="medium-btn grey-btn" onClick={handleBack} icon={<BackIcon />}>
          <span className="back-text">BACK</span>
        </Button>

        {showRestoreBtn && (
          <Button className="medium-btn secondary-btn restore-btn" {...restoreBtnProps}>
            RESTORE
          </Button>
        )}
      </div>
    </div>
  );
};

HistoryHeader.propTypes = {
  backupPreviewId: PropTypes.string,
  backupPreviewLoading: PropTypes.bool,
  restoreProposal: PropTypes.func,
  approved: PropTypes.bool,
  isWix: PropTypes.bool,
};

export default HistoryHeader;
